import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {AuthenticationService, SnackbarService} from '../../services';

@Component({
    selector: 'prism-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [UntypedFormBuilder],
})
export class LoginComponent {
    showLoaderSub: Subscription;
    loggedInSub: Subscription;
    showLoader$: Observable<boolean> = this.authService.showLoginLoader.asObservable();
    logo: string = this.route.snapshot.data['logo'];
    logoAlt: string = this.route.snapshot.data['alt'];
    resetRoute: string[] = this.route.snapshot.data['resetRoute'];
    minPassChars = 6;
    loginForm: UntypedFormGroup = this.formBuilder.group({
        email: ['', [Validators.required, Validators.email]],
        password: [
            '',
            [Validators.required, Validators.minLength(this.minPassChars)],
        ],
    });

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthenticationService,
        private snackbarService: SnackbarService
    ) {
        this.showLoaderSub = this.showLoader$.subscribe(
            () => null,
            () => console.warn(`Error occurred during login loader subscription`),
            () => this.showLoaderSub.unsubscribe()
        );
        
        // Subscribe to logged in state changes
        this.loggedInSub = this.authService.isLoggedIn$().subscribe(isLoggedIn => {
            if (isLoggedIn === false) {
                // User logged out, reset and enable the form
                this.loginForm.reset();
                this.loginForm.enable();
            }
        });
    }

    public onLogin(validState) {
        if (validState) {
            const email = this.loginForm.controls['email'].value;
            const password = this.loginForm.controls['password'].value;

            if (this.loginForm.valid) {
                this.loginForm.disable();
                this.authService.login(email, password).catch((error) => {
                    this.loginForm.enable();
                    this.snackbarService.handleError(error);
                });
            }
        }
    }
}
